import "@arenza/typefaces-museo-sans";
import PropTypes from "prop-types";
import React from "react";
import { useLocation } from '@reach/router';
import store from "store2";

import "../assets/main.module.scss";
import "../../../../node_modules/swiper/modules/navigation.css";
import "../../../../node_modules/swiper/modules/pagination.css";
import "../../../../node_modules/swiper/swiper.css";
import '@Development/ui-kit/dist/index.css';

import BannerAuto from '../components/BannerAuto';
import LayoutAdaptiveWrapper from "./LayoutAdaptiveWrapper";
import LayoutApplicationContext from "./LayoutApplicationContext";
import LayoutNavigation from "./LayoutNavigation";

Layout.propTypes = {
  children: PropTypes.node,
};

export const EQUIPMENT_TYPE = 'property_type'

export default function Layout({ children }) {
    const { pathname } = useLocation();

    const arenzaStorage = store.namespace('arenza');


    if (pathname.includes('lizing-auto')) {
        arenzaStorage(EQUIPMENT_TYPE, 'arenza_auto')
    } else if (pathname.includes('lizing-meditsinskogo-oborudovaniya')) {
        arenzaStorage(EQUIPMENT_TYPE, 'arenza_medicine')
    } else if (pathname.includes('shiny-v-lizing')) {
        arenzaStorage(EQUIPMENT_TYPE, 'arenza_tires')
    } else {
        arenzaStorage(EQUIPMENT_TYPE, 'arenza_equipment')
    }

  return (
    <LayoutAdaptiveWrapper>
      <LayoutApplicationContext>
        <LayoutNavigation>
            {children}
        </LayoutNavigation>

        <BannerAuto />
      </LayoutApplicationContext>
    </LayoutAdaptiveWrapper>
  );
}
